export enum InputType {
  TEXT = 'text',
  TEL = 'tel',
  EMAIL = 'email',
  SEARCH = 'search',
  NUMBER = 'number',
  HIDDEN = 'hidden',
  DATE = 'date',
  SELECT = 'select',
  TEXTAREA = 'textarea'
}
